<template>
  <ValidationObserver v-slot="{ valid }">
    <unicom-filtro-v2
      titulo="Filtrar PTU"
      :value="mostrar"
      @limpar-filtro="limpar"
      @fechar="fecharFiltro"
      @filtrar="filtrar"
      :bloquearBotaoFiltro="!valid"
      invertido
    >
      <div slot="corpo-subtitulo">
        Selecione os dados desejados,<br />
        depois clique em FILTRAR.
      </div>
      <div slot="corpo-filtro" style="margin: 0 32px">
        <unicom-linha espacamento class="fonte-secundaria espacamento-filtro">
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-autocomplete
              mostrarIconeExcluir
              colorPlaceholder="#9E9E9E"
              placeholder="Selecione um analista"
              titulo="Analista"
              v-model="objetoFiltro.analista.descricao"
              @index="
                index =>
                  selecionarChave(index, 'analista', listaAnalistas, 'id')
              "
              :items="listaAnalistas.map(e => e.nomeComPapel)"
            />
          </unicom-coluna>
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-campo-calendario-v3
              fecharClique
              regrasValidacao="validacaoDataPassada|validacaoDataPassada"
              tituloCampo="Data da observação inicial"
              :customMessages="{ validacaoDataPassada: 'Data superior à hoje' }"
              :duploClique="false"
              v-model="objetoFiltro.dataInicialObservacao"
              placeHolder="Selecione a data"
              colorPlaceholder="#9E9E9E"
              mostrarIconeExcluir
            />
          </unicom-coluna>
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-campo-calendario-v3
              fecharClique
              :regrasValidacao="
                `validacaoDataPassada|validacaoDatafinalMaiorDataInicial: ${objetoFiltro.dataInicialObservacao}`
              "
              tituloCampo="Data da observação final"
              :customMessages="{ validacaoDataPassada: 'Data superior à hoje' }"
              :duploClique="false"
              v-model="objetoFiltro.dataFinalObservacao"
              placeHolder="Selecione a data"
              colorPlaceholder="#9E9E9E"
              mostrarIconeExcluir
            />
          </unicom-coluna>
        </unicom-linha>
      </div>
    </unicom-filtro-v2>
  </ValidationObserver>
</template>

<script>
import FiltroMixin from "@/shared/mixin/FiltroMixin";
import { ValidationObserver } from "vee-validate";

export default {
  mixins: [FiltroMixin],
  components: {
    ValidationObserver
  },
  props: {
    listaAnalistas: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      objetoFiltro: {},
      objetoFiltroVazio: {
        analista: {
          chave: "",
          descricao: ""
        },
        dataInicialObservacao: "",
        dataFinalObservacao: ""
      }
    };
  },
  beforeMount() {
    this.objetoFiltro = JSON.parse(JSON.stringify(this.objetoFiltroVazio));
  },
  methods: {
    filtrar() {
      const {
        analista: { chave: chaveAnalista = undefined },
        dataInicialObservacao = undefined,
        dataFinalObservacao = undefined
      } = this.objetoFiltro;

      const objetoFiltro = {
        usuarioCriacaoId: chaveAnalista,
        criacaoFromData: this.$helpers.formatadorISO(dataInicialObservacao),
        criacaoToData: this.$helpers.formatadorISO(dataFinalObservacao)
      };

      this.$emit("filtrar", objetoFiltro);
      this.$emit("filtroPuro", this.objetoFiltro);
    },
    limparCampos() {
      this.objetoFiltro = JSON.parse(JSON.stringify(this.objetoFiltroVazio));
    }
  }
};
</script>

<style lang="scss">
.espacamento-filtro {
  .col-12 {
    padding-top: 24px;
  }
}
</style>
